import React from "react";

function SocialLink({ id, href, icon, itemClass }) {
  return (
    <li>
      <a href={href} target="_blank" rel="noreferrer" className={itemClass}>
        <i className={icon}></i>
      </a>
    </li>
  );
}

export default SocialLink;
